import { QueryClient } from "@tanstack/react-query";

import isRunningOnClient from "@/utils/isRunningOnClient";

const STALE_TIME_IN_SECONDS = 60;

let browserQueryClient: QueryClient | undefined;

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid re-fetching immediately on the client
        staleTime: STALE_TIME_IN_SECONDS * 1000,
      },
    },
  });
}

function getQueryClient() {
  const isRunningOnServerSide = !isRunningOnClient();

  if (isRunningOnServerSide) {
    return makeQueryClient(); // If on Server side: always make a NEW query client
  }

  // On Browser: makes a NEW query client only IF we don't already have one.
  // This is very important, so we don't re-make a new client if React
  // suspends during the initial render. This may not be needed if we
  // have a suspense boundary BELOW the creation of the query client
  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient();
  }

  return browserQueryClient;
}

export default getQueryClient;
